// extracted by mini-css-extract-plugin
module.exports = {"menus":"index_menus_29DfX","icon":"index_icon_2luA7","title":"index_title_17pG8"};